<template>
    <div class="page">
        <v-container>
            <v-card :flat="phoneOnly" class="px-lg-3 py-lg-3">

                <!-- Calendar Header -->
                <v-toolbar flat class="mb-lg-4 w-full px-0" height="55">
                    <v-spacer v-if="pcOnly"></v-spacer>
                    <v-toolbar-title class="d-flex align-center" :class="{'mx-auto': phoneOnly}">
                        <v-btn color="primary" width="35" height="35" outlined depressed @click="prev">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <div class="mx-4">{{title}}</div>
                        <v-btn color="primary" width="35" height="35" outlined depressed @click="next">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-toolbar-title>
                    <v-spacer v-if="pcOnly"></v-spacer>
                </v-toolbar>
                <div>
                    <v-select v-model="calendarType" filled :items="[{text: 'Month Calendar', value: 'month'}, {text: 'Week Calendar', value: 'week'}]" class="rounded mx-md-auto" :style="pcOnly ? 'max-width: 300px' : ''"></v-select>
                </div>

                <!-- Calendar -->
                <!-- <div style="position: relative">
                    <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary" ></v-progress-linear>
                </div> -->
                <div :style="phoneOnly ? 'overflow-x: scroll;' : ''" style="border: 1px solid rgba(0,0,0, 0.1)!important;">
                    <v-calendar
                    ref="calendar"
                    v-model="selected"
                    :weekdays="[6, 0, 1, 2, 3, 4, 5]"
                    :type="calendarType"
                    color="primary"
                    :events="events"
                    event-overlap-mode="stack"
                    :event-overlap-threshold="30"
                    :event-color="getEventColor"
                    @change="getEvents"
                    @click:event="showEvent"
                    :loading="true"
                    style="min-height: 80vh; min-width: 1000px">
                    <template v-slot:event="{ event, timed, eventSummary }">
                        <component :is="{ render: eventSummary }" />
                    </template>
                </v-calendar>
                </div>
                <v-subheader class="mt-4 ps-0">Color Keys</v-subheader>
                    <div class="calendar-keys d-flex flex-wrap mb-2">
                        <v-chip small dark color="primary" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Coming Classes</span>
                        </v-chip>
                        <v-chip small dark color="success" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Running</span>
                        </v-chip>
                        <v-chip small dark color="green darken-2" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Completed</span>
                        </v-chip>
                        <v-chip small dark color="grey darken-2" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Missed</span>
                        </v-chip>
                        <v-chip small dark color="teal darken-2" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Trial</span>
                        </v-chip>
                        <!-- <v-chip small dark color="blue-grey darken-1" outlined class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <div class="key-color blue-grey darken-1 me-1"></div>
                            <span>Scheduled</span>
                        </v-chip> -->
                        <v-chip small dark color="indigo" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Rescheduled</span>
                        </v-chip>
                        <v-chip small dark color="red darken-1" class="d-flex me-2 px-3 mb-2 mb-lg-0" style="opacity: 0.7;">
                            <span>Canceled</span>
                        </v-chip>
                        <v-chip small dark color="black" class="d-flex me-2 px-3 mb-2 mb-lg-0">
                            <span>Absent</span>
                        </v-chip>
                    </div>
            </v-card>
        </v-container>

        <v-dialog v-if="classDialogEvent" v-model="showClassDialog" :transition="phoneOnly ? 'slide-y-transition' : 'slide-y-transition'" max-width="375" overlay-color="#000000">
            <class-card v-if="showClassDialogCard" :class-data="classDialogEvent" @close="showClassDialog = false" />
        </v-dialog>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import ClassCard from '@/components/custom/class-card'

export default {
    name: "Calendar",
    components: {
        ClassCard
    },
    data(){
        return {
            calendarType: 'week',

            title: '',
            selected: '',
            loading: false,
            
            showClassDialog: false,
            showClassDialogCard: false,
            classDialogEvent: null,

            interval: null,
        }
    },
    computed: {
        ...GlobalComputed,
        fetchedCalendar(){
            return this.$store.state.userModule.calendar ;
        },
        events(){
            console.log('fetchedCalendar', this.fetchedCalendar);
            if (!this.fetchedCalendar) return [];
            return this.fetchedCalendar.map((item, i)=>{
                const color = item.absent ? 'black' : (item.canceled ? 'red darken-1' : (item.full_status === 'missed' ? 'grey darken-2' : ( item.status === 'expired' ? 'green darken-2' : (item.status === 'running' ? 'success' : (item.payment_status === 'trial' ? 'teal darken-2' : (item.rescheduled ? 'indigo' : (item.id ? 'primary' : 'primary')))))));
                const name = this.isTeacher ? item.enrollment.student.name + ' - ' + item.enrollment.course.name : item.enrollment.course.name;
                return {
                    ...item,

                    name: name,
                    start: new Date(item.start), // start is ms timestamp
                    end: new Date(item.end), // end is ms timestamp

                    color: color,
                    timed: true,
                }
            });
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;

                return this.$store.dispatch('fetchCalendar', { startDate: this.selected }).then(response=>{
                    this.loading = false;

                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        showEvent(event){
            this.showClassDialog = true;
            this.classDialogEvent = event.event;
        },
        next(){
            this.$refs.calendar.next();
        },
        prev(){
            this.$refs.calendar.prev();
        },
        setToday(){
            this.selected = '';
        },
        getEvents ({ start, end }) {
            this.title = this.$refs.calendar.title;
            this.loadData();
        },
        getEventColor (event) {
            return event.color
        },
        backButtonHandler(){
            if (this.showClassDialog){
                this.showClassDialog = false;
            }else{
                this.$router.go(-1);
            }
        },
        ...GlobalMethods
    },
    watch: {
        fetchedCalendar(calendar){
            if (this.classDialogEvent){
                const event = calendar.find(item=>item.id === this.classDialogEvent.id);
                if (event){
                    this.classDialogEvent = event;
                }
            }
        },
        showClassDialog(show){
            if (show){
                this.showClassDialogCard = true;
            }else{
                window.setTimeout(()=>{
                    this.showClassDialogCard = false;
                }, 400);
            }
        },
    },
    mounted(){
        if (this.pcOnly){
            this.calendarType = 'month';
        }

        if (this.capRunning){
            document.addEventListener('backbuttonclicked', this.backButtonHandler);
        }
    },
    created(){
        const timeout = this.appData.calendar_reload_timeout || 20000;
        this.interval = window.setInterval(()=>{
            this.loadData();
        }, timeout)
    },
    beforeDestroy(){
        window.clearInterval(this.interval);
        if (this.capRunning){
            document.removeEventListener('backbuttonclicked', this.backButtonHandler)
        }
    },
};
</script>

<style lang="scss" scoped>
.key-color{
    width: 12px;
    height: 12px;
    border-radius: 2px;
}
</style>
<style lang="scss">
.v-calendar{
    box-shadow: 0 1px 15px rgba(0,0,0, .1)!important;
    border: none!important;
    padding: 10px;
    .v-calendar-weekly__head{
        border-top: 1px solid rgba(0,0,0, .1);
    }
    
    .v-event-timed{
        /* weekly and daily */
        
        margin-right: auto!important;
        margin-left: auto!important;
        margin-bottom: 3px!important;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;

        font-size: 12.5px!important;
        font-weight: 500;
        line-height: 1.2rem;
    }
    .v-event{
        height: 35px!important;
        margin-right: auto!important;
        margin-left: auto!important;
        margin-bottom: 3px!important;
        border-radius: 12px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;

        font-size: 12.5px!important;
        font-weight: 500;

        &.red{
            opacity: 0.7;
        }
    }
    .v-calendar-weekly__day-label{
        margin: 4px 0;
    }
    .v-calendar-weekly__day .v-btn.v-btn--fab{
        border-radius: 14px!important;
    }
    .v-calendar-weekly__day.v-present{
        // background: #fff3ed!important;
        border: 1px solid #b1b1b1!important;

        .v-btn.v-btn--fab{
            background: #fafafa!important;
            color: #8a1e25!important;
            font-weight: bold;
            border: 1px solid;
        }
    }
}
</style>